import React from "react";
import {
  FaFacebook,
  FaGithub,
  FaInstagram,
  FaLinkedin,
  FaTwitter,
} from "react-icons/fa";
import { GrMail } from "react-icons/gr";

const Footer = () => {
  return (
    <footer>
      <h4>Developed by Gopi Mishra</h4>
      <h4>Copyright &copy; 2024 GOPI MISHRA</h4>
      <div className="footerLinks">
        <a href="https://github.com/gopimishra71" target="_blank">
          <FaGithub />
        </a>
        <a href="https://www.linkedin.com/in/gopimishra71" target="_blank">
          <FaLinkedin />
        </a>
        <a href="mailTo:contact.gopimishra@gmail.com" target="_blank">
          <GrMail />
        </a>
        <a href="https://instagram.com/gopimishra71" target="_blank">
          <FaInstagram />
        </a>
        <a href="https://facebook.com/gopimishra711" target="_blank">
          <FaFacebook />
        </a>
        <a href="https://twitter.com/gopimishra711" target="_blank">
          <FaTwitter />
        </a>
      </div>
    </footer>
  );
};

export default Footer;
